"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AesCrypto = void 0;

var _cryptoJs = _interopRequireDefault(require("crypto-js"));

var INTERNAL_SECRET = 'f49c75778fa711f0';
var AesCrypto = {
  AES_ALGORITHM: 'AES-CBC',
  AES_IV: '4162032485566718',
  handleDecryptKey: function handleDecryptKey(secretKey) {
    var src = secretKey == null ? '' : String(secretKey);
    var fixed = src.length >= 16 ? src.slice(0, 16) : src.padEnd(16, "\0");
    return _cryptoJs["default"].enc.Utf8.parse(fixed);
  },
  getCryptoKey: function getCryptoKey(secretKey) {
    var keySrc = secretKey || INTERNAL_SECRET;
    return this.handleDecryptKey(keySrc);
  },
  getIv: function getIv() {
    return _cryptoJs["default"].enc.Utf8.parse(this.AES_IV);
  },
  aesEncrypt: function aesEncrypt(plainData, secretKey) {
    try {
      var key = this.getCryptoKey(secretKey);
      var iv = this.getIv();

      var cipher = _cryptoJs["default"].AES.encrypt(plainData, key, {
        iv: iv,
        mode: _cryptoJs["default"].mode.CBC,
        padding: _cryptoJs["default"].pad.Pkcs7
      });

      return cipher.toString();
    } catch (error) {
      console.error('加密失败:', error);
      throw new Error('加密失败: ' + error.message);
    }
  },
  aesDecrypt: function aesDecrypt(encryptedData, secretKey) {
    try {
      var key = this.getCryptoKey(secretKey);
      var iv = this.getIv();

      var decrypted = _cryptoJs["default"].AES.decrypt(encryptedData, key, {
        iv: iv,
        mode: _cryptoJs["default"].mode.CBC,
        padding: _cryptoJs["default"].pad.Pkcs7
      });

      return _cryptoJs["default"].enc.Utf8.stringify(decrypted);
    } catch (error) {
      console.error('解密失败:', error);
      throw new Error('解密失败: ' + error.message);
    }
  }
};
exports.AesCrypto = AesCrypto;